import Img from "react-cloudimage-responsive";
import { useState } from "react";
import { OnHoldLoadBet, SelectRps } from "pages/uGame/urps";
import { GetTransactionRPSRoomRepsonse } from "lib/worker/api/get_transaction_rps_room";
import rps_fight_rps_bet from "lib/worker/api/rps_fight_rps_bet";
import getinfo from "lib/worker/api/getinfo";
import { alertWithMessage } from "components/modal/message_modal";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import Spinner from "components/view/loader";

interface RpsRoomProps {
  room: GetTransactionRPSRoomRepsonse;
  isLogin: boolean;
  state: AppReducerStateProps;
  rpsroom: SelectRps[];
  onLoading: Function;
  onHoldLoadBet: OnHoldLoadBet[];
}

function RpsRoom(props: RpsRoomProps) {
  const { room, onHoldLoadBet, rpsroom } = props;
  const [selectRps, setSelectRps] = useState<SelectRps | null>();

  const onClickRps = (hashkey: string, value: SelectRps | undefined) => {
    if (!props.isLogin) {
      alertWithMessage("กรุณาเข้าสู่ระบบ ถึงจะสามารถเล่นเกมได้");
      return;
    }

    if (selectRps != null && selectRps.rps == value?.rps) {
      setSelectRps(null);
    } else {
      setSelectRps(value);
    }

    props.onLoading(hashkey, true, value);

    fightBet(value?.id)
      .then(() => {
        getinfo();
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        setSelectRps(null);
        props.onLoading(hashkey, false, value);
      });
  };

  const fightBet = async (bet_result_id?: number | undefined) => {
    return rps_fight_rps_bet({
      bet_result_id: bet_result_id,
      hashkey: room.Hash_key,
    });
  };

  const displayRPS = (value: SelectRps) => {
    for (let index = 0; index < onHoldLoadBet.length; index++) {
      const element = onHoldLoadBet[index];
      if (element.hashkey == room.Hash_key) {
        if (value.id == element.selectRps.id) {
          return (
            <div
              key={room.Hash_key + value.rps}
              onClick={() => {
                onClickRps(room.Hash_key ?? "", value);
              }}
              className={"col-4 margin-top-10 margin-bottom-10 grid select-div"}
            >
              <div key={room.Hash_key + value.rps + "spinner"}>
                <Spinner></Spinner>
              </div>
            </div>
          );
        }
      }
    }

    return (
      <div
        key={room.Hash_key + value.rps}
        onClick={() => {
          onClickRps(room.Hash_key ?? "", value);
        }}
        className={"col-4 margin-top-10 margin-bottom-10 grid select-div"}
      >
        <div key={room.Hash_key + value.rps + "spinner"}>
          <Img
            key={room.Hash_key + value.rps + ""}
            ratio={1 / 1}
            src={value.rpsimgs ?? ""}
            className={`${selectRps && selectRps.rps == value.rps ? "" : ""}`}
            alt={value.rpsimgs}
          ></Img>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        key={room.Hash_key}
        className="col-12 col-md-6 col-lg-4 margin-bottom-10 grid"
      >
        <div className="view-background-blue bg-blue text-center">
          <div
            className="bg-head-rps"
            style={{ paddingTop: 5, paddingBottom: 5 }}
          >
            <div className="col-12">
              <div>
                <h4
                  style={{
                    fontSize: 14,
                    marginTop: 5,
                    float: "left",
                    marginLeft: 10,
                  }}
                >
                  {room.Username}
                </h4>
              </div>
              <div className="bg-blue margin-right-10">
                <div
                  style={{
                    float: "right",
                    fontSize: 12,
                    marginTop: 3,
                    borderRadius: 3,
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                  className="bg-success"
                >
                  {((room.Amount ?? 0) * -1).format(0, 0)}
                </div>
                <div
                  className="icon-head"
                  style={{ float: "right", marginTop: 3 }}
                >
                  <Img
                    ratio={1 / 1}
                    src="uDiamond-nav-icon-blue.png"
                    alt="cash - เครดิต"
                  ></Img>
                </div>
              </div>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
          <div className="row wrapper center-row-content col-12 col-md-8 col-lg-8">
            {rpsroom.map((value) => displayRPS(value))}
          </div>
          <div className="bg-head-rps">
            <div className="col-12">
              <div className="">
                <div className="bg-blue">
                  <div
                    style={{
                      float: "right",
                      fontSize: 10,
                      marginRight: 10,
                      borderRadius: 3,
                    }}
                  >
                    {room.DisplayCreatedAt}
                  </div>
                </div>
              </div>
            </div>
            <div style={{ clear: "both" }}></div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    isLogin: state.member.isLogin,
    state: state,
  };
};

export default connect(mapStateToProps)(RpsRoom);
